import { oc } from '@orpc/contract';
import { listProductBindingsInputSchema, listProductBindingsOutputSchema } from '../schemas/board.schemas.js';
export const listProductBindingsContract = oc
    .route({
    method: 'GET',
    path: '/board/product-bindings',
    tags: ['Board'],
    summary: 'Every product × metric (sold, delivered) with the KPI it is bound to (ADMIN, PM)',
})
    .input(listProductBindingsInputSchema)
    .output(listProductBindingsOutputSchema);
//# sourceMappingURL=list-product-bindings.contract.js.map